import { signal } from "@preact/signals-react";

import NumericInlineField from "componentsv2/form/NumericInlineField";
import { useWizard } from "storev2/wizardStore";

function StepOpen() {
  const data = signal(0);
  const { store } = useWizard();

  function onChange(fieldName, value) {
    store[fieldName] = value;
  }

  const attrs = {
    label: "account.statement.start_balance",
    name: "start_balance",
    type: "number",
    onChange: onChange,
  };

  return (
    <div key="account-statement-open" className="my-6 md:mx-24">
      <NumericInlineField attrs={attrs} data={data} />
    </div>
  );
}

export default StepOpen;
